export class Environment {
  public static SELECTED = import.meta.env.ID_FE_ENV

  public static PRODUCTION = 'prod'
  public static STAGING = 'stg'
  public static TESTING = 'test'
  public static DEVELOPMENT = 'dev'

  public static isEnvLikeProduction = (): boolean => {
    return this.SELECTED === this.PRODUCTION || this.SELECTED === this.STAGING
  }

  public static isEnvLikeDevelopment = (): boolean => {
    return (
      this.SELECTED === this.STAGING ||
      this.SELECTED === this.TESTING ||
      this.SELECTED === this.DEVELOPMENT
    )
  }
}
